var map = {
	"./buds-screenshot.jpg": 421,
	"./condensed-screenshot.jpg": 91,
	"./contact.png": 410,
	"./mentor-screenshot.jpg": 512,
	"./paymate-screenshot.jpg": 127,
	"./profile.png": 989,
	"./robo-screenshot.jpg": 866,
	"./sarah.png": 489,
	"./wordle-screenshot.jpg": 735
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;